import { render, staticRenderFns } from "./PagesGiftcardBuyboxWidget.vue?vue&type=template&id=64d7c6e9&"
import script from "./PagesGiftcardBuyboxWidget.vue?vue&type=script&lang=js&"
export * from "./PagesGiftcardBuyboxWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports